export const replacePathId = (path: string, id: string) => {
  if (!path.includes(':id')) {
    throw new Error('id params not found');
  }

  return path.replace(':id', id);
};
